import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import SitePage from "@/swof/SitePage";
import { AuthProvider } from "@/admin/AuthContext";
import ProtectedRoute from "@/admin/ProtectedRoute";
import LoginPage from "@/admin/LoginPage";
import { ForgotPasswordPage, ResetPasswordPage, UitnodigingPage } from "@/admin/PasswordPages";
import AdminPage from "@/admin/AdminPage";
import BlockEditPage from "@/admin/BlockEditPage";
import { MediaPage, VideosPage, GalerijPage, PersonenPage } from "@/admin/MediaPages";
import PersoonEditPage from "@/admin/PersoonEditPage";
import PublicatiesPage from "@/admin/PublicatiesPage";
import BeheerdersPage from "@/admin/BeheerdersPage";
import InschrijvingenPage from "@/admin/InschrijvingenPage";
import PartnersPage from "@/admin/PartnersPage";

const beveiligd = (element) => <ProtectedRoute>{element}</ProtectedRoute>;

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<SitePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/wachtwoord-vergeten" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/uitnodiging" element={<UitnodigingPage />} />
          <Route path="/admin/beheerders" element={beveiligd(<BeheerdersPage />)} />
          <Route path="/admin/inschrijvingen" element={beveiligd(<InschrijvingenPage />)} />
          <Route path="/admin/partners" element={beveiligd(<PartnersPage />)} />
          <Route path="/admin" element={beveiligd(<AdminPage />)} />
          <Route path="/admin/blok/:blockId" element={beveiligd(<BlockEditPage />)} />
          <Route path="/admin/media" element={beveiligd(<MediaPage />)} />
          <Route path="/admin/videos" element={beveiligd(<VideosPage />)} />
          <Route path="/admin/galerij" element={beveiligd(<GalerijPage />)} />
          <Route path="/admin/inductees" element={beveiligd(<PersonenPage soort="inductees" />)} />
          <Route path="/admin/inductees/:persoonId" element={beveiligd(<PersoonEditPage soort="inductees" />)} />
          <Route path="/admin/bestuursleden" element={beveiligd(<PersonenPage soort="bestuursleden" />)} />
          <Route path="/admin/bestuursleden/:persoonId" element={beveiligd(<PersoonEditPage soort="bestuursleden" />)} />
          <Route path="/admin/publicaties" element={beveiligd(<PublicatiesPage />)} />
          <Route path="/voorbeeld" element={beveiligd(<SitePage concept />)} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
